/**
 * Z-Index Scale - Layering order for positioned elements.
 *
 * Usage:
 *   import { zIndex } from '@/theme';
 *   sx={{ zIndex: zIndex.dropdown }}
 *
 * Organization:
 * - Lower numbers = further back
 * - Higher numbers = closer to user
 * - Leave gaps for future insertions (10, 20, 30... not 1, 2, 3)
 *
 * Adding new values:
 * - Extract from existing code, don't invent
 * - Name by PURPOSE (dropdown, modal) not by number
 * - Consider what it needs to appear above/below
 */

export const zIndex = {
  /** 1 - Local stacking within a component (above siblings) */
  local: 1,
  /** 10 - Elevated elements within page (sidebars, loading overlays) */
  elevated: 10,
  /** 100 - Sticky headers and navigation */
  sticky: 100,
  /** 400 - App shell lower layer */
  appShell: 400,
  /** 500 - App shell upper layer */
  appShellTop: 500,
  /** 1300 - Modal/dialog layer (StyledDialog overlay + content) */
  modal: 1300,
  /** 1400 - Above modals: popovers/listboxes opened INSIDE a dialog must clear
   * the 1300 modal layer, or they paint behind it (Issue 13). Must stay > modal. */
  aboveModal: 1400,
} as const;
